<template>
<div id="bg">
  <AlertQueue></AlertQueue>

    <vs-row vs-justify="center" class="centered">
      <vs-col
        type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="3"
        vs-sm="12"
        vs-xs="12"
      >
        <vs-card class="cardx">

          <div slot="header">
            <div class="card-title d-flex"><img v-bind:src="getLogoPath()"/>
              <div class="ml-auto text-right">
                <vs-button @click="showVersion=true" size="small" color="primary" type="flat" icon="help"></vs-button>
              </div>
            </div>
          </div>
          <div slot="media">
            <img :src="require('@/assets/images/welcome_screens/welcome1.jpg')"/>
          </div>
          <vs-tabs v-model="tabIdx" id="loginTabs">

            <vs-tab label="Benutzer">
                <div class="d-flex">
                <vs-input
                icon-border
                icon="account_circle"
                class="mt-3 width100proz"
                label-placeholder="Benutzername"
                ref="userInput"
                v-model="username" id="inputUsername" @keyup.enter="tabIdx += 1"/>
                </div>
            </vs-tab>
            <vs-tab label="Passwort" >                
                <vs-input
                type="password"
                icon-border
                :disabled="pwDisabled"
                icon="lock"
                ref="pwInput"
                class="mt-3 width100proz"
                label-placeholder="Kennwort"
                v-model="password" @keyup.enter="tabIdx += 1"/>
            </vs-tab>
            <vs-tab label="OTP (Einmalpasswort)" >                
                <vs-input
                type="password"
                icon-border
                :disabled="otpDisabled"
                icon="lock"
                ref="otpInput"
                class="mt-3 width100proz"
                label-placeholder="OTP"
                v-model="otp" @keyup.enter="login"/>
            </vs-tab>            
          </vs-tabs>

          <div slot="footer">
            <vs-row vs-justify="flex-end">
              <vs-button ref="backBtn" v-show="tabIdx > 0" class="ml-3" color="primary" icon="keyboard_arrow_left" @click="tabIdx -= 1" :disabled="!backEnabled">Zurück</vs-button>
              <vs-button ref="nextBtn" v-show="tabIdx < maxTabIdx" class="ml-3" color="primary" icon="keyboard_arrow_right" @click="tabIdx += 1" :disabled="!nextEnabled">Weiter</vs-button>
              <vs-button ref="loginBtn" v-show="tabIdx == maxTabIdx" class="ml-3" color="success" icon="check" @click="login" :disabled="!loginEnabled">Anmelden</vs-button>
            </vs-row>
          </div>
        </vs-card>
        <vs-popup :title="'Version '+programmVersion" :active.sync="showVersion">
          <p>Infra Evolution Vertriebssystem - Fairplay<br/>
          Umgebung: <span v-if="!testActive">Produktion</span><span v-if="testActive">TEST</span><br/>
          Version: {{programmVersion}}</p>
          <p><a target="blank" href="https://www.infraevolution.at/de/impressum">Infra Evolution Impressum</a></p>
          <vs-collapse>
            <vs-collapse-item>
              <div slot="header">
                <h4>Verwendete Bibliotheken</h4>
              </div>
              <vs-table 
                :data="lic"
                stripe
                max-items="5" 
                pagination
                hoverFlat>
                <template slot="header">
                </template>
                <template slot="thead">
                  <vs-th>
                    Name
                  </vs-th>
                  <vs-th>
                    Lizenz
                  </vs-th>
                  <vs-th>
                    Version
                  </vs-th>
                  <vs-th>
                    Link
                  </vs-th>     
                  <vs-th>
                    Author
                  </vs-th>                               
                </template>

                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                    <vs-td :data="tr.name">
                      {{tr.name}}
                    </vs-td>
                    <vs-td :data="tr.licenseType">
                      {{tr.licenseType}}
                    </vs-td>
                    <vs-td :data="tr.installedVersion">
                      {{tr.installedVersion}}
                    </vs-td>
                    <vs-td :data="tr.link">
                      <a :href="tr.link" target="_blank">{{tr.link}} </a>
                    </vs-td>
                    <vs-td :data="tr.author">
                      <a v-if="tr.author.includes('@')" :href="getEmailFromAuthor(tr.author)">{{getNameFromAuthor(tr.author)}} ({{getEmailFromAuthor(tr.author)}})</a>
                      
                      <span v-else> {{getNameFromAuthor(tr.author)}}</span>
                    </vs-td>                                        
                  </vs-tr>
                </template>
              </vs-table>
            </vs-collapse-item>
          </vs-collapse>
        </vs-popup>
      </vs-col>   
    </vs-row>
</div>
</template>

<style>
  body, html {
    height: 100%;
  }
  #app{
    height: 100%;
  }
  #bg {
    /* The image used */
    background-image: url("../../assets/images/background/login.jpg");
    /* Full height */
    height: 100%;

    /* Center and scale the image nicely */
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

#login_box {
  background-color:white;
  padding:30px 20px 30px 20px;
  box-shadow: 8px 8px 30px 3px #c3c3c3;
	border: 1px solid #c3c3c3
}
#login_box i{
  font-size: 18px;
}  
#login_box h1
{
    text-align: center;
}
#login_box img{
  display: block;
  margin-left: auto;
  margin-right: auto;
}
div#loginTabs > .con-ul-tabs{
  display: none;
}

</style>

<script>

import AlertQueue from '../AlertQueue';
import { router } from '../../router';
import staticCodeHelper from '../../helper/staticCodeHelper';
import staticFuncHelper from '../../helper/staticFuncHelper';

export default {
  name: "LoginPage",
  components: {
    AlertQueue
  },
  data: () => ({
    topbarColor: "#4F5467",
    logotitle: "Vertriebssystem 2.0",
    username: '',
    password: '',
    otp:'',
    submitted: false,
    tabIdx:0,
    maxTabIdx:2,
    nextEnabled:false,
    backEnabled:true,
    loginEnabled:false,
    pwDisabled:true,
    otpDisabled:true,
    showVersion:false,
    // erstellt mit tool "license-report"
    // C:\Daten\Infra evolution\Vertriebssystem2.0\work>license-report --output=json
    // zusätzlich gibts noch den license-checker
    // C:\Daten\Infra evolution\Vertriebssystem2.0\work>license-checker --summary --out "C:\Daten\Infra evolution\Vertriebssystem2.0\work\lic\sum.txt"
    lic:[{"department":"kessler","relatedTo":"stuff","name":"@babel/runtime-corejs2","licensePeriod":"perpetual","material":"material","licenseType":"MIT","link":"https://github.com/babel/babel.git","remoteVersion":"7.24.4","installedVersion":"7.18.3","definedVersion":"^7.18.3","author":"The Babel Team (https://babel.dev/team)"},{"department":"kessler","relatedTo":"stuff","name":"@casl/ability","licensePeriod":"perpetual","material":"material","licenseType":"MIT","link":"git+https://github.com/stalniy/casl.git","remoteVersion":"3.4.0","installedVersion":"3.4.0","definedVersion":"^3.4.0","author":"Sergii Stotskyi <sergiy.stotskiy@freaksidea.com>"},{"department":"kessler","relatedTo":"stuff","name":"@casl/vue","licensePeriod":"perpetual","material":"material","licenseType":"MIT","link":"git+https://github.com/stalniy/casl.git","remoteVersion":"0.5.1","installedVersion":"0.5.1","definedVersion":"^0.5.1","author":"Sergii Stotskyi <sergiy.stotskiy@freaksidea.com>"},{"department":"kessler","relatedTo":"stuff","name":"@microsoft/sse","licensePeriod":"perpetual","material":"material","licenseType":"MIT","link":"git+https://github.com/dotnet/aspnetcore.git","remoteVersion":"6.0.25","installedVersion":"6.0.5","definedVersion":"^6.0.1","author":"Microsoft"},{"department":"kessler","relatedTo":"stuff","name":"apexcharts","licensePeriod":"perpetual","material":"material","licenseType":"MIT","link":"git+https://github.com/apexcharts/apexcharts.js.git","remoteVersion":"3.48.0","installedVersion":"3.35.3","definedVersion":"^3.35.2","author":"n/a"},{"department":"kessler","relatedTo":"stuff","name":"axios","licensePeriod":"perpetual","material":"material","licenseType":"MIT","link":"git+https://github.com/axios/axios.git","remoteVersion":"0.21.4","installedVersion":"0.21.4","definedVersion":"^0.21.1","author":"Matt Zabriskie"},{"department":"kessler","relatedTo":"stuff","name":"chart.js","licensePeriod":"perpetual","material":"material","licenseType":"MIT","link":"git+https://github.com/chartjs/Chart.js.git","remoteVersion":"2.9.4","installedVersion":"2.9.4","definedVersion":"^2.8.0","author":"n/a"},{"department":"kessler","relatedTo":"stuff","name":"core-js","licensePeriod":"perpetual","material":"material","licenseType":"MIT","link":"git+https://github.com/zloirock/core-js.git","remoteVersion":"2.6.12","installedVersion":"2.6.12","definedVersion":"^2.6.5","author":"n/a"},{"department":"kessler","relatedTo":"stuff","name":"fibers","licensePeriod":"perpetual","material":"material","licenseType":"MIT","link":"git://github.com/laverdet/node-fibers.git","remoteVersion":"4.0.3","installedVersion":"4.0.3","definedVersion":"^4.0.2","author":"Marcel Laverdet <marcel@laverdet.com> (https://github.com/laverdet/)"},{"department":"kessler","relatedTo":"stuff","name":"file-saver","licensePeriod":"perpetual","material":"material","licenseType":"MIT","link":"git+https://github.com/eligrey/FileSaver.js.git","remoteVersion":"1.3.8","installedVersion":"1.3.8","definedVersion":"^1.3.2","author":"Eli Grey me@eligrey.com"},{"department":"kessler","relatedTo":"stuff","name":"luxon","licensePeriod":"perpetual","material":"material","licenseType":"MIT","link":"git+https://github.com/moment/luxon.git","remoteVersion":"1.28.1","installedVersion":"1.28.0","definedVersion":"^1.23.0","author":"Isaac Cambron"},{"department":"kessler","relatedTo":"stuff","name":"material-icons","licensePeriod":"perpetual","material":"material","licenseType":"Apache-2.0","link":"git+https://github.com/marella/material-icons.git","remoteVersion":"0.3.1","installedVersion":"0.3.1","definedVersion":"^0.3.1","author":"n/a"},{"department":"kessler","relatedTo":"stuff","name":"prismjs","licensePeriod":"perpetual","material":"material","licenseType":"MIT","link":"git+https://github.com/PrismJS/prism.git","remoteVersion":"1.29.0","installedVersion":"1.28.0","definedVersion":"^1.17.1","author":"Lea Verou"},{"department":"kessler","relatedTo":"stuff","name":"vue","licensePeriod":"perpetual","material":"material","licenseType":"MIT","link":"git+https://github.com/vuejs/vue.git","remoteVersion":"2.7.16","installedVersion":"2.6.14","definedVersion":"^2.6.10","author":"Evan You"},{"department":"kessler","relatedTo":"stuff","name":"vue-apexcharts","licensePeriod":"perpetual","material":"material","licenseType":"MIT","link":"https://github.com/apexcharts/vue-apexcharts/issues","remoteVersion":"1.6.2","installedVersion":"1.6.2","definedVersion":"^1.6.2","author":"Juned Chhipa juned.chhipa@gmail.com"},{"department":"kessler","relatedTo":"stuff","name":"vue-chartjs","licensePeriod":"perpetual","material":"material","licenseType":"MIT","link":"git+ssh://git@github.com/apertureless/vue-chartjs.git","remoteVersion":"3.5.1","installedVersion":"3.5.1","definedVersion":"^3.4.2","author":"Jakub Juszczak <jakub@posteo.de>"},{"department":"kessler","relatedTo":"stuff","name":"vue-datetime","licensePeriod":"perpetual","material":"material","licenseType":"MIT","link":"git+https://github.com/mariomka/vue-datetime.git","remoteVersion":"1.0.0-beta.14","installedVersion":"1.0.0-beta.14","definedVersion":"^1.0.0-beta.11","author":"Mario Juárez <mario@mjp.one>"},{"department":"kessler","relatedTo":"stuff","name":"vue-easy-dnd","licensePeriod":"perpetual","material":"material","licenseType":"MIT","link":"git+https://github.com/rlemaigre/Easy-DnD.git","remoteVersion":"1.22.0","installedVersion":"1.22.0","definedVersion":"^1.10.2","author":"Régis Lemaigre <rlemaigre.github@gmail.com>"},{"department":"kessler","relatedTo":"stuff","name":"vue-i18n","licensePeriod":"perpetual","material":"material","licenseType":"MIT","link":"git+https://github.com/kazupon/vue-i18n.git","remoteVersion":"8.28.2","installedVersion":"8.27.1","definedVersion":"^8.16.0","author":"kazuya kawaguchi kawakazu80@gmail.com"},{"department":"kessler","relatedTo":"stuff","name":"vue-prism-component","licensePeriod":"perpetual","material":"material","licenseType":"MIT","link":"git+https://github.com/egoist/vue-prism-component.git","remoteVersion":"1.2.0","installedVersion":"1.2.0","definedVersion":"^1.1.1","author":"egoist <0x142857@gmail.com>"},{"department":"kessler","relatedTo":"stuff","name":"vue-router","licensePeriod":"perpetual","material":"material","licenseType":"MIT","link":"git+https://github.com/vuejs/vue-router.git","remoteVersion":"3.6.5","installedVersion":"3.5.4","definedVersion":"^3.1.3","author":"Evan You"},{"department":"kessler","relatedTo":"stuff","name":"vue2-dropzone","licensePeriod":"perpetual","material":"material","licenseType":"MIT","link":"git+ssh://git@github.com/rowanwins/vue-dropzone.git","remoteVersion":"3.6.0","installedVersion":"3.6.0","definedVersion":"^3.6.0","author":"rowanwins <@rowanwins>"},{"department":"kessler","relatedTo":"stuff","name":"vuesax","licensePeriod":"perpetual","material":"material","licenseType":"MIT","link":"git+https://github.com/lusaxweb/vuesax.git","remoteVersion":"3.12.2","installedVersion":"3.12.2","definedVersion":"^3.12.2","author":"ldrovira <luisdanielrovira8@gmail.com>"},{"department":"kessler","relatedTo":"stuff","name":"vuex","licensePeriod":"perpetual","material":"material","licenseType":"MIT","link":"git+https://github.com/vuejs/vuex.git","remoteVersion":"3.6.2","installedVersion":"3.6.2","definedVersion":"^3.1.1","author":"Evan You"},{"department":"kessler","relatedTo":"stuff","name":"weekstart","licensePeriod":"perpetual","material":"material","licenseType":"MIT","link":"git://github.com/gamtiq/weekstart.git","remoteVersion":"1.1.0","installedVersion":"1.1.0","definedVersion":"^1.0.1","author":"Denis Sikuler"},{"department":"kessler","relatedTo":"stuff","name":"@vue/cli-plugin-babel","licensePeriod":"perpetual","material":"material","licenseType":"MIT","link":"git+https://github.com/vuejs/vue-cli.git","remoteVersion":"3.12.1","installedVersion":"3.12.1","definedVersion":"^3.11.0","author":"Evan You"},{"department":"kessler","relatedTo":"stuff","name":"@vue/cli-plugin-eslint","licensePeriod":"perpetual","material":"material","licenseType":"MIT","link":"git+https://github.com/vuejs/vue-cli.git","remoteVersion":"3.12.1","installedVersion":"3.12.1","definedVersion":"^3.11.0","author":"Evan You"},{"department":"kessler","relatedTo":"stuff","name":"@vue/cli-service","licensePeriod":"perpetual","material":"material","licenseType":"MIT","link":"git+https://github.com/vuejs/vue-cli.git","remoteVersion":"4.5.19","installedVersion":"4.5.17","definedVersion":"^4.5.10","author":"Evan You"},{"department":"kessler","relatedTo":"stuff","name":"babel-eslint","licensePeriod":"perpetual","material":"material","licenseType":"MIT","link":"git+https://github.com/babel/babel-eslint.git","remoteVersion":"10.1.0","installedVersion":"10.1.0","definedVersion":"^10.0.1","author":"Sebastian McKenzie <sebmck@gmail.com>"},{"department":"kessler","relatedTo":"stuff","name":"eslint","licensePeriod":"perpetual","material":"material","licenseType":"MIT","link":"git+https://github.com/eslint/eslint.git","remoteVersion":"5.16.0","installedVersion":"5.16.0","definedVersion":"^5.16.0","author":"Nicholas C. Zakas <nicholas+npm@nczconsulting.com>"},{"department":"kessler","relatedTo":"stuff","name":"eslint-plugin-vue","licensePeriod":"perpetual","material":"material","licenseType":"MIT","link":"git+https://github.com/vuejs/eslint-plugin-vue.git","remoteVersion":"5.2.3","installedVersion":"5.2.3","definedVersion":"^5.0.0","author":"Toru Nagashima (https://github.com/mysticatea)"},{"department":"kessler","relatedTo":"stuff","name":"node-sass","licensePeriod":"perpetual","material":"material","licenseType":"MIT","link":"git+https://github.com/sass/node-sass.git","remoteVersion":"4.14.1","installedVersion":"4.14.1","definedVersion":"^4.14.1","author":"Andrew Nesbitt andrewnez@gmail.com http://andrew.github.com"},{"department":"kessler","relatedTo":"stuff","name":"sass-loader","licensePeriod":"perpetual","material":"material","licenseType":"MIT","link":"git+https://github.com/webpack-contrib/sass-loader.git","remoteVersion":"8.0.2","installedVersion":"8.0.2","definedVersion":"^8.0.0","author":"J. Tangelder"},{"department":"kessler","relatedTo":"stuff","name":"vue-template-compiler","licensePeriod":"perpetual","material":"material","licenseType":"MIT","link":"git+https://github.com/vuejs/vue.git","remoteVersion":"2.7.16","installedVersion":"2.6.14","definedVersion":"^2.6.10","author":"Evan You"}]
  }),
    computed: {
      //überwacht Zustandsänderung in Modulen und macht diese unter einem Name abrufbar
        loggingIn () {
            return this.$store.state.authentication.status.loggingIn;
        },
        logInFail () 
        {
            return this.$store.state.authentication.status.logInFail;
        },
        getErrorMessage () {
          return this.$store.state.alert.message;
        },
        programmVersion(){
          return this.$appConfig.version;
        },
        testActive(){
          return this.$appConfig.testActive;
        }
    },
    created () {
        // reset login status
        localStorage.removeItem('authtokens');
        this.$vs.loading.close();
    },
    mounted(){
      // Einmal alle Banner laden, refresh erfolgt dann über polling
      this.$store.dispatch('polling/getPublicBanners', { root: true },{ root: true }); 
      this.$store.dispatch('maincontainer/setSseConnectionStatus', false,{root: true},{root: true}); 
      this.tabIdx = 0;
    },
    watch: {
      //wird aufgerufen wen sich "logInFail" ändert
      logInFail(value){
          if(value)
          {
            this.submitted = false;
            this.username = "";
            this.password = "";
            this.otp = "";
            this.$store.dispatch('alertqueue/hideLoader', {'id':''});
          }
      },
      loggingIn (value)
      {
        if(value)
          this.$store.dispatch('alertqueue/showLoader', {'id':''});
      },
      username(){
        this.checkButtonState(this.tabIdx);
      },
      password(){
        this.checkButtonState(this.tabIdx);
      },
      otp(){
        this.checkButtonState(this.tabIdx);
      },
      tabIdx(value){
        this.checkButtonState(value);
        switch(value)
        {
          case 0:
            this.$nextTick(() => this.setFocusOnInput('userInput'));
            break;
          case 1:
            this.$nextTick(() => this.setFocusOnInput('pwInput'));
            break; 
          case 2:
            this.$nextTick(() => this.setFocusOnInput('otpInput'));
            break;         
        }
      },
    },
    methods: {
        ...staticCodeHelper,
        ...staticFuncHelper,
        getLogoPath(){
          var path = require('@/assets/images/logo/ie_logo_menu.png');
          if(this.testActive == true)
          {
            path = require('@/assets/images/logo/ie_logo_menu_test.png');
          }
          return path;
        },
        login(){
          if (this.username && this.password)
            {
                this.$store.dispatch('authentication/login', { username:this.username, password:this.password, otp:this.otp })      
                .then(resp => {
        
                  if(resp.success == true)
                  {
                    router.push('/');
                  }
                  else
                  {
                    this.$vs.notify({title:'Anmeldung fehlgeschlagen!',text:resp.message,color:'danger',icon:'error'});
                    this.tabIdx = 0;
                  }
                }, 
                error =>{
                  var text = "Anmeldung fehlgeschlagen! ";
                   if(this.IsNotNull(error))
                   {
                     text = error.message;
                   }
                   this.$vs.notify({title:'Anmeldung fehlgeschlagen!',text:text,color:'danger',icon:'error'});
                   this.tabIdx = 0;
                });  
            }
        },
        checkButtonState(idx){
          this.pwDisabled = this.username.length <= 0;
          switch(idx)
          {
            case 0:
              this.nextEnabled = this.username.length > 0;
              this.backEnabled = true;
              this.loginEnabled = false;
              this.otpDisabled = true;
              break;  
            case 1:
              this.nextEnabled = true;
              this.backEnabled = true;
              this.otpDisabled = true;
              this.loginEnabled = false;
              break;              
            case 2:
              this.nextEnabled = false;
              this.backEnabled = true;
              this.otpDisabled = false;
              this.loginEnabled = this.password.length > 0 && this.username.length > 0;
              break;                      
          }
        },
        getEmailFromAuthor(author)
        {
           let resp = author;

            if(resp.includes("@"))
            {
              const myArray = resp.split(" ");
              myArray.forEach(element => {
                if(element.includes("@"))
                {
                  resp = element.replaceAll("<","");
                  resp = resp.replaceAll(">","");
                }
              });
            }

           return resp;
        },
        getNameFromAuthor(author)
        {
           let resp = author;

            if(resp.includes("@"))
            {
              resp = "";
              const myArray = author.split(" ");
              myArray.forEach(element => {
                if(element.includes("@") == false)
                {
                  resp += ' ' + element;
                }
              });
            }

           return resp;
        }
    }
};



</script>